import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  root: {
    position: "relative",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  card: {
    minHeight: "calc(100vh - 144px) !important",
  },
  appBar: {
    margin: "8px 0",
    backgroundColor: 'rgba(66, 66, 66, 1)'
  }
});
